import React, { useEffect, useState } from "react";
import { Box, TextareaAutosize, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface OrderDetailsTextAreaProps {
    value: string;
    maxLength: number;
    onBlur: (value: string) => void;
    disabled?: boolean;
    driverComments?: string;
    autoFocus: boolean;
}

export const OrderDetailsTextArea: React.FC<OrderDetailsTextAreaProps> = ({
    value,
    maxLength,
    onBlur,
    disabled = false,
    driverComments,
    autoFocus,
}) => {
    const { t } = useTranslation();
    const [text, setText] = useState(value);

    useEffect(() => {
        if (value !== text) {
            setText(value);
        }
    }, [value]);

    const handleBlur = () => {
        if (text.length <= maxLength) {
            onBlur(text);
        }
    };

    return (
        <Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
                {t("common.characterCount", {
                    count: text.length,
                    max: maxLength,
                })}
            </Typography>
            <TextareaAutosize
                autoFocus={autoFocus}
                value={text}
                onChange={(e) => setText(e.target.value)}
                onBlur={handleBlur}
                disabled={disabled}
                style={{
                    width: "100%",
                    minHeight: "100px",
                    padding: "8px",
                    fontSize: "14px",
                    borderColor: "#ccc",
                    borderRadius: "4px",
                }}
                maxLength={maxLength}
            />
            <Box sx={{ mt: 2, mb: 2 }}>
                <Typography
                    color="primary.dark"
                    variant="h4"
                    sx={{ mt: 2, mb: 2 }}
                >
                    {t("transport.order.driversComments")}
                </Typography>
                {driverComments ? (
                    <div className="text">{driverComments}</div>
                ) : (
                    <div className="text">-</div>
                )}
            </Box>
        </Box>
    );
};
